var _g, _path, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _g3, _path0, _path1, _path10, _g4, _path11, _path12, _path13, _g5, _path14, _path15, _g6, _path16, _path17, _g7, _path18, _g8, _path19, _path20, _g9, _g0, _g1, _g10, _path21, _g11, _g12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 5.60445L16.5701 4.89738L9.48145 17.8315L11.0238 18.0019L17.7856 5.60445Z",
    fill: "url(#paint0_linear_91_5220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 5.60445L16.5701 4.89738L9.48145 17.8315L11.0238 18.0019L17.7856 5.60445Z",
    fill: "url(#paint1_radial_91_5220)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 5.60445L16.5701 4.89738L9.48145 17.8315L11.0238 18.0019L17.7856 5.60445Z",
    fill: "url(#paint2_linear_91_5220)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 5.60445L16.5701 4.89738L9.48145 17.8315L11.0238 18.0019L17.7856 5.60445Z",
    fill: "url(#paint3_radial_91_5220)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 5.60445L16.5701 4.89738L9.48145 17.8315L11.0238 18.0019L17.7856 5.60445Z",
    fill: "url(#paint4_radial_91_5220)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7856 5.60445L16.5701 4.89738L9.48145 17.8315L11.0238 18.0019L17.7856 5.60445Z",
    fill: "url(#paint5_radial_91_5220)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3586 5.60445L13.1419 4.89738L6.30469 17.4844L7.59619 18.0019L14.3586 5.60445Z",
    fill: "url(#paint6_linear_91_5220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3586 5.60445L13.1419 4.89738L6.30469 17.4844L7.59619 18.0019L14.3586 5.60445Z",
    fill: "url(#paint7_radial_91_5220)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3586 5.60445L13.1419 4.89738L6.30469 17.4844L7.59619 18.0019L14.3586 5.60445Z",
    fill: "url(#paint8_linear_91_5220)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3586 5.60445L13.1419 4.89738L6.30469 17.4844L7.59619 18.0019L14.3586 5.60445Z",
    fill: "url(#paint9_radial_91_5220)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3586 5.60445L13.1419 4.89738L6.30469 17.4844L7.59619 18.0019L14.3586 5.60445Z",
    fill: "url(#paint10_radial_91_5220)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3586 5.60445L13.1419 4.89738L6.30469 17.4844L7.59619 18.0019L14.3586 5.60445Z",
    fill: "url(#paint11_radial_91_5220)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3586 5.60445L13.1419 4.89738L6.30469 17.4844L7.59619 18.0019L14.3586 5.60445Z",
    fill: "url(#paint12_linear_91_5220)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.79329 4.80959L11.0089 5.51665L6.57861 13.6397L6.31592 11.1546L9.79329 4.80959Z",
    fill: "url(#paint13_linear_91_5220)"
  }))), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79378 4.80963L11.0093 5.51669L6.57909 13.6398L6.31641 11.1546L9.79378 4.80963Z",
    fill: "url(#paint14_radial_91_5220)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79378 4.80963L11.0093 5.51669L6.57909 13.6398L6.31641 11.1546L9.79378 4.80963Z",
    fill: "url(#paint15_linear_91_5220)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79378 4.80963L11.0093 5.51669L6.57909 13.6398L6.31641 11.1546L9.79378 4.80963Z",
    fill: "url(#paint16_linear_91_5220)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_iii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6184 7.423L12.5361 18.5217H14.1674L18.2641 11.0106L18.6184 7.423Z",
    fill: "url(#paint17_linear_91_5220)"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6184 7.423L12.5361 18.5217H14.1674L18.2641 11.0106L18.6184 7.423Z",
    fill: "url(#paint18_linear_91_5220)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6184 7.423L12.5361 18.5217H14.1674L18.2641 11.0106L18.6184 7.423Z",
    fill: "url(#paint19_linear_91_5220)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6184 7.423L12.5361 18.5217H14.1674L18.2641 11.0106L18.6184 7.423Z",
    fill: "url(#paint20_radial_91_5220)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.57373 6.02742L7.78986 5.32036L15.014 18.5042L13.3355 18.4249L6.57373 6.02742Z",
    fill: "url(#paint21_linear_91_5220)"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57373 6.02742L7.78986 5.32036L15.014 18.5042L13.3355 18.4249L6.57373 6.02742Z",
    fill: "url(#paint22_linear_91_5220)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57373 6.02742L7.78986 5.32036L15.014 18.5042L13.3355 18.4249L6.57373 6.02742Z",
    fill: "url(#paint23_linear_91_5220)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55859 5.20509L10.7742 4.49803L17.8628 17.4316L16.3204 17.602L9.55859 5.20509Z",
    fill: "url(#paint24_linear_91_5220)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55811 5.20509L10.7737 4.49803L17.8623 17.4316L16.3199 17.602L9.55811 5.20509Z",
    fill: "url(#paint25_linear_91_5220)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55811 5.20509L10.7737 4.49803L17.8623 17.4316L16.3199 17.602L9.55811 5.20509Z",
    fill: "url(#paint26_linear_91_5220)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.86824 11.0089L10.4594 19.4267L12.1379 19.5054L5.86768 8.06474L5.86824 11.0089Z",
    fill: "url(#paint27_linear_91_5220)"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.86873 11.0089L10.4599 19.4267L12.1384 19.5054L5.86816 8.06474L5.86873 11.0089Z",
    fill: "url(#paint28_linear_91_5220)"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3906 6.02517V5.75967H14.8588L17.7624 11.0584L17.3225 13.2336L13.3906 6.02517Z",
    fill: "url(#paint29_linear_91_5220)"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3906 6.02517V5.75967H14.8588L17.7624 11.0584L17.3225 13.2336L13.3906 6.02517Z",
    fill: "url(#paint30_linear_91_5220)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3906 6.02517V5.75967H14.8588L17.7624 11.0584L17.3225 13.2336L13.3906 6.02517Z",
    fill: "url(#paint31_linear_91_5220)"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3807 6.01508L17.6229 5.99258L15.9883 18.8159L17.7461 18.8384L19.3807 6.01508Z",
    fill: "url(#paint32_linear_91_5220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3807 6.01508L17.6229 5.99258L15.9883 18.8159L17.7461 18.8384L19.3807 6.01508Z",
    fill: "url(#paint33_radial_91_5220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3807 6.01508L17.6229 5.99258L15.9883 18.8159L17.7461 18.8384L19.3807 6.01508Z",
    fill: "url(#paint34_radial_91_5220)"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_i_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.61035 5.43458L6.36816 5.41264L8.00335 18.236L6.24554 18.2579L4.61035 5.43458Z",
    fill: "url(#paint35_linear_91_5220)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61035 5.43458L6.36816 5.41264L8.00335 18.236L6.24554 18.2579L4.61035 5.43458Z",
    fill: "url(#paint36_radial_91_5220)"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8951 4.14244H5.24543C4.6412 4.14244 4.15137 4.63227 4.15137 5.2365V5.23707C4.15137 5.8413 4.6412 6.33113 5.24543 6.33113H18.8951C19.4993 6.33113 19.9891 5.8413 19.9891 5.23707V5.2365C19.9891 4.63227 19.4993 4.14244 18.8951 4.14244Z",
    fill: "#CCCBCD"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_ii_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2606 17.6425H6.8802C6.27596 17.6425 5.78613 18.1323 5.78613 18.7365V18.7371C5.78613 19.3413 6.27596 19.8312 6.8802 19.8312H17.2606C17.8648 19.8312 18.3546 19.3413 18.3546 18.7371V18.7365C18.3546 18.1323 17.8648 17.6425 17.2606 17.6425Z",
    fill: "#CCCBCD"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2606 17.6425H6.8802C6.27596 17.6425 5.78613 18.1323 5.78613 18.7365V18.7371C5.78613 19.3413 6.27596 19.8312 6.8802 19.8312H17.2606C17.8648 19.8312 18.3546 19.3413 18.3546 18.7371V18.7365C18.3546 18.1323 17.8648 17.6425 17.2606 17.6425Z",
    fill: "url(#paint37_linear_91_5220)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_f_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.04492 4.58125H19.0842C19.1822 4.58125 19.2762 4.62019 19.3456 4.6895C19.4149 4.7588 19.4538 4.8528 19.4538 4.95082C19.4538 5.04883 19.4149 5.14283 19.3456 5.21214C19.2762 5.28144 19.1822 5.32038 19.0842 5.32038H6.04492V4.58125Z",
    fill: "url(#paint38_linear_91_5220)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter13_f_91_5220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0083 18.1521H17.4669C17.5649 18.1521 17.6589 18.1911 17.7282 18.2604C17.7975 18.3297 17.8364 18.4237 17.8364 18.5217C17.8364 18.6197 17.7975 18.7137 17.7282 18.783C17.6589 18.8523 17.5649 18.8912 17.4669 18.8912H7.0083V18.1521Z",
    fill: "url(#paint39_linear_91_5220)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_91_5220",
    x: 9.33145,
    y: 4.74738,
    width: 8.6042,
    height: 13.4046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.631373 0 0 0 0 0.627451 0 0 0 0 0.643137 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.796078 0 0 0 0 0.780392 0 0 0 0 0.835294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_91_5220",
    x: 6.15469,
    y: 4.74738,
    width: 8.35371,
    height: 13.4046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.580392 0 0 0 0 0.576471 0 0 0 0 0.592157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.635294 0 0 0 0 0.603922 0 0 0 0 0.709804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_91_5220",
    x: 6.16592,
    y: 4.65959,
    width: 4.99287,
    height: 9.13012,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.521569 0 0 0 0 0.533333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623529 0 0 0 0 0.588235 0 0 0 0 0.698039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_iii_91_5220",
    x: 12.3861,
    y: 7.198,
    width: 6.45752,
    height: 11.4737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.225,
    dy: -0.225
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.225
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.886275 0 0 0 0 0.92549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.556863 0 0 0 0 0.541176 0 0 0 0 0.584314 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.901961 0 0 0 0 0.941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_91_5220",
    result: "effect3_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_91_5220",
    x: 6.42373,
    y: 5.17036,
    width: 8.74043,
    height: 13.4839,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.647059 0 0 0 0 0.619608 0 0 0 0 0.705882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.909804 0 0 0 0 0.898039 0 0 0 0 0.945098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_91_5220",
    x: 9.40859,
    y: 4.34803,
    width: 8.6042,
    height: 13.404,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662745 0 0 0 0 0.631373 0 0 0 0 0.737255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.886275 0 0 0 0 0.87451 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_91_5220",
    x: 5.71768,
    y: 7.91474,
    width: 6.57002,
    height: 11.7407,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.498039 0 0 0 0 0.478431 0 0 0 0 0.537255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.85098 0 0 0 0 0.898039 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_91_5220",
    x: 13.2406,
    y: 5.60967,
    width: 4.67158,
    height: 7.77394,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.15,
    dy: -0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.67451 0 0 0 0 0.639216 0 0 0 0 0.74902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.15,
    dy: 0.15
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.780392 0 0 0 0 0.776471 0 0 0 0 0.8 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_91_5220",
    x: 15.9883,
    y: 5.80508,
    width: 3.58008,
    height: 13.0333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875,
    dy: -0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.470588 0 0 0 0 0.529412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_i_91_5220",
    x: 4.61035,
    y: 5.22514,
    width: 3.58057,
    height: 13.0327,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.1875,
    dy: -0.1875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.486275 0 0 0 0 0.470588 0 0 0 0 0.529412 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_91_5220",
    x: 4.15137,
    y: 3.39244,
    width: 16.1379,
    height: 2.93869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.631373 0 0 0 0 0.596078 0 0 0 0 0.713726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.552941 0 0 0 0 0.509804 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_ii_91_5220",
    x: 5.78613,
    y: 16.8925,
    width: 12.8684,
    height: 2.93869,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.631373 0 0 0 0 0.596078 0 0 0 0 0.713726 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_91_5220"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.3,
    dy: -0.3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.552941 0 0 0 0 0.509804 0 0 0 0 0.639216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_91_5220",
    result: "effect2_innerShadow_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_f_91_5220",
    x: 5.48242,
    y: 4.01875,
    width: 14.5337,
    height: 1.86412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125,
    result: "effect1_foregroundBlur_91_5220"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_f_91_5220",
    x: 6.4458,
    y: 17.5896,
    width: 11.9531,
    height: 1.86412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.28125,
    result: "effect1_foregroundBlur_91_5220"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_5220",
    x1: 17.2029,
    y1: 5.24501,
    x2: 10.1053,
    y2: 18.1741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5D2DF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5797 11.4201) rotate(33.6901) scale(1.52109 10.4436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E2F1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_91_5220",
    x1: 16.7636,
    y1: 5.54876,
    x2: 16.2888,
    y2: 7.62326,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#776D8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A0B6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3919 9.22241) rotate(154.564) scale(0.798064 4.90363)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#847A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5CFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.6539 12.0358) rotate(151.238) scale(1.20557 7.40751)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#847A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5CFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8943 14.9357) rotate(152.488) scale(0.951334 5.84539)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#847A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5CFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_91_5220",
    x1: 13.7758,
    y1: 5.24501,
    x2: 6.88237,
    y2: 17.8017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B9B3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6B3C0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3696 9.59202) rotate(122.412) scale(6.55892 2.36447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3CDE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3CDE1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_91_5220",
    x1: 13.3427,
    y1: 5.53695,
    x2: 12.8651,
    y2: 7.55182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#80759B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B2AAC4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.0253 9.11223) rotate(155.362) scale(0.783017 4.85389)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#847A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5CFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3331 11.8414) rotate(152.002) scale(1.18095 7.344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.237,
    stopColor: "#847A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5CFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.61943 14.6563) rotate(153.266) scale(0.932456 5.79189)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.402,
    stopColor: "#847A97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5CFE2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_91_5220",
    x1: 7.5,
    y1: 16.711,
    x2: 8.97656,
    y2: 15.8673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#9B98A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B98A1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_91_5220",
    x1: 10.2416,
    y1: 6.34015,
    x2: 7.34136,
    y2: 11.0156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A098B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4AFC0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.87578 7.79426) rotate(-27.7182) scale(0.642216 1.89901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#868489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A49DB7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_91_5220",
    x1: 7.32441,
    y1: 11.086,
    x2: 7.81659,
    y2: 10.8402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#908E95"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#908E95",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_91_5220",
    x1: 10.4885,
    y1: 6.05894,
    x2: 9.59184,
    y2: 7.13107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.341,
    stopColor: "#9186A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9186A9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_91_5220",
    x1: 17.3264,
    y1: 12.3516,
    x2: 14.6191,
    y2: 17.4496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2BECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E4ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_91_5220",
    x1: 17.2206,
    y1: 13.5295,
    x2: 16.2363,
    y2: 13.3186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.401,
    stopColor: "#797487"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#797487",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_91_5220",
    x1: 17.2909,
    y1: 11.8066,
    x2: 16.5175,
    y2: 12.3426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.643,
    stopColor: "#726A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#726A85",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3481 15.4006) rotate(151.699) scale(0.648844 3.54425)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#857D98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEBAC8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_91_5220",
    x1: 7.46473,
    y1: 7.00786,
    x2: 14.3908,
    y2: 18.8462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADA8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#CEC8DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D3E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_91_5220",
    x1: 7.15648,
    y1: 5.66798,
    x2: 7.86467,
    y2: 7.35098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.264,
    stopColor: "#867E98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#867E98",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_91_5220",
    x1: 14.4774,
    y1: 17.7955,
    x2: 13.6545,
    y2: 16.6035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0CFD3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0CFD3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_91_5220",
    x1: 10.1413,
    y1: 4.84509,
    x2: 17.239,
    y2: 17.7742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5C0D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607,
    stopColor: "#D8D3E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_91_5220",
    x1: 16.5061,
    y1: 15.9618,
    x2: 15.758,
    y2: 15.8262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.176,
    stopColor: "#8E8A99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7C3D1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_91_5220",
    x1: 10.7517,
    y1: 5.63709,
    x2: 10.7517,
    y2: 6.81441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#978FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C2D8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_91_5220",
    x1: 6.18999,
    y1: 10.3311,
    x2: 8.49343,
    y2: 16.1951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A19DAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBCC7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_91_5220",
    x1: 6.97291,
    y1: 12.3167,
    x2: 8.06248,
    y2: 12.2812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.047,
    stopColor: "#8F8D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F8D97",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_91_5220",
    x1: 14.7772,
    y1: 6.35761,
    x2: 17.3174,
    y2: 10.8902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4BFD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D5E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_91_5220",
    x1: 15.3324,
    y1: 6.06961,
    x2: 15.2756,
    y2: 6.84474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.323,
    stopColor: "#7D758C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C1D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_91_5220",
    x1: 17.1324,
    y1: 12.1761,
    x2: 16.7634,
    y2: 12.1581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#69676E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D5E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_91_5220",
    x1: 16.8168,
    y1: 12.4152,
    x2: 18.6095,
    y2: 12.6503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#B2AEBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2CEDC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.3802 6.30477) rotate(97.849) scale(12.4211 0.987177)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFCBD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CFCBD9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.014 5.81258) rotate(155.072) scale(3.33646 0.752117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#797090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C869C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_91_5220",
    x1: 5.91816,
    y1: 14.0746,
    x2: 7.39473,
    y2: 13.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.082,
    stopColor: "#B2AEBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2CEDC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_91_5220",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.97766 5.23264) rotate(24.928) scale(3.33646 0.752117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.331,
    stopColor: "#797090"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C869C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_91_5220",
    x1: 13.6527,
    y1: 19.8312,
    x2: 13.6527,
    y2: 19.3125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9881BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A899C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_91_5220",
    x1: 18.979,
    y1: 4.95082,
    x2: 2.6688,
    y2: 4.95082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C7CD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_91_5220",
    x1: 17.4534,
    y1: 18.5217,
    x2: 4.28186,
    y2: 18.5217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDEE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C7CD",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinIcon);
export default __webpack_public_path__ + "static/media/bin-icon.4d6c0a8c2404a65101cd74b270ee0dd4.svg";
export { ForwardRef as ReactComponent };